const NotFound = () => {
    return (
        <div>
            <h1>404 Not Found</h1>
            <p>This page does not exist</p>
        </div>
    )
}

export default NotFound;